import { render, staticRenderFns } from "./ProductChooser.vue?vue&type=template&id=bc19de70&lang=pug&"
import script from "./ProductChooser.vue?vue&type=script&lang=js&"
export * from "./ProductChooser.vue?vue&type=script&lang=js&"
import style0 from "./ProductChooser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports